/**
 * Enum to order the settings shown within the quick settings pane.
 * Each setting that is shown in the quick settings pane should have a unique entry
 * in the enum, and in the order to be shown in the quick settings pane.
 */
var QuickSettingOrder;
(function (QuickSettingOrder) {
    // All workloads
    QuickSettingOrder[QuickSettingOrder["Theme"] = 0] = "Theme";
    QuickSettingOrder[QuickSettingOrder["DarkMode"] = 1] = "DarkMode";
    // Mail workload
    QuickSettingOrder[QuickSettingOrder["Conversations"] = 2] = "Conversations";
    QuickSettingOrder[QuickSettingOrder["ReadingPane"] = 3] = "ReadingPane";
    QuickSettingOrder[QuickSettingOrder["Focused"] = 4] = "Focused";
    QuickSettingOrder[QuickSettingOrder["SenderImage"] = 5] = "SenderImage";
    QuickSettingOrder[QuickSettingOrder["DateHeaders"] = 6] = "DateHeaders";
    QuickSettingOrder[QuickSettingOrder["InlinePreview"] = 7] = "InlinePreview";
    QuickSettingOrder[QuickSettingOrder["PreviewText"] = 8] = "PreviewText";
    QuickSettingOrder[QuickSettingOrder["DesktopNotifications"] = 9] = "DesktopNotifications";
    // Calendar workload
    QuickSettingOrder[QuickSettingOrder["RegionalSettings"] = 10] = "RegionalSettings";
    QuickSettingOrder[QuickSettingOrder["CalendarAppearance"] = 11] = "CalendarAppearance";
})(QuickSettingOrder || (QuickSettingOrder = {}));
export default QuickSettingOrder;
//# sourceMappingURL=QuickSettingOrder.js.map